// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const nymble: PokeData = {
  "id": 919,
  "name": "nymble",
  "height": 2,
  "weight": 10,
  "base_experience": 42,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "double-kick",
    "tackle",
    "leer",
    "agility",
    "screech",
    "endure",
    "astonish",
    "feint",
    "assurance",
    "sucker-punch",
    "bug-bite",
    "struggle-bug",
    "first-impression"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "leer",
    "bug-bite",
    "sticky-web",
    "string-shot",
    "pin-rush",
    "bug-buzz",
    "leech-steal",
    "heal-order",
    "infest",
    "pounce",
    "lunge"
  ],
  "evolution_chain": {
    "id": 483,
    "item": null,
    "species": [
      {
        "name": "nymble",
        "order": 920,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lokix",
        "order": 921,
        "types": [
          PokeType.BUG,
          PokeType.DARK
        ],
        "evolves_from_species_id": 919,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 32.75,
    "speed": 45,
    "ability_power": 46
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
